import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { hamburgerMenuDataEn } from './hamburgerMenuData.en';
import { hamburgerMenuDataEs } from './hamburgerMenuData.es';
import type { HamburgerMenuData } from './types/HamburgerMenuData';

export const hamburgerMenuDataByLocale: Record<I18nLocale, HamburgerMenuData> =
  {
    en: hamburgerMenuDataEn,
    es: hamburgerMenuDataEs,
  };
